<template>
    <table class="tbl-basic-info" :id="id">
        <caption></caption>
        <colgroup>
            <col style="width: 140px;">
            <col>
        </colgroup>
        <tbody>
        <tr>
            <th scope="row">{{ $t('LABEL.PRODUCT')}}<!--Product--></th>
            <td>
                <ul class="list-seperate">
                    <template v-if="rule.autoExeYn==='N'">{{$t('LABEL.MANUAL_RULE')}}</template>
                    <li v-for="(prod, index) of getProducts" :key="index">
                        <span class="icon-vender"
                            :data-vendor="prod.vendor"
                            data-size="s">{{$t('PRODUCT.'+prod.prod)}}
                        </span>
                    </li>
                </ul>
            </td>
        </tr>
        <tr>
            <th scope="row">{{ $t('LABEL.SEVERITY')}}<!--Severity--></th>
            <td>
                    <span class="icon-serious"
                          v-bind:data-status="rule.svrty == 1 ? 'low' : rule.svrty == 2 ? 'medium' : rule.svrty == 3 ? 'high' :'critical' "> {{$t("LABEL.SVRTY." + rule.svrty)}}</span>
            </td>
        </tr>
        <tr>
            <th scope="row">{{ $t('LABEL.DESCRIPTION')}}<!--Description--></th>
            <td>
                <p v-if="parentsType === 'plcy'">
                    {{rule.siteCd == constants.POLICY_TYPE.BEST_PRACTICE ? rule[$i18n.locale+'RuleDesc'] : rule.desc}}
                </p>
                <p v-else-if="parentsType === 'cmpl'">
                    {{rule.userDefiYn == constants.PARAM.SELECT.N ? rule[$i18n.locale+'RuleDesc'] : rule.ruleDesc}}
                </p>
            </td>
        </tr>
        <tr v-if="parentsType === 'cmpl'">
            <th scope="row">{{ $t('POLICY.RULE.SIDE_DETAIL.RELATED_ACCOUNT')}}<!--연관 계정--></th>
            <td>
                <div class="toggle-accounts">
                    <div class="accounts" :data-expand="isAccuntOpen ? true : null">
                        <span v-for="(acc, index) of rule.accAlias" :key="index">
                            <span class="icon-tag" data-type="account" v-if="checkAccountRelateRule(acc.split('%$%')[1])">
                                <span :data-vendor="acc.split('%$%')[1]" class="icon-vender" data-size="s"></span>
                                {{acc.split('%$%')[0]}}
                            </span>
                        </span>
                    </div>
                    <button v-if="isAccountView" type="button" class="txt-status btn-toggle-accounts" data-status="key" v-on:click="openAccountSection()">
                        <span class="expand"> {{$t('COMPLIANCE.DETAIL.EA_MORE', {cnt : remainerCnt})}}</span>
                        <span class="collapse">{{ $t('COMMON.BUTTON.CAMEL.COLLAPSE')}}</span>
                    </button>
                </div>
            </td>
        </tr>

        <tr>
            <th rowspan="2" scope="row">{{ $t('POLICY.RULE.SIDE_DETAIL.DETAILS')}}<!--상세내용--></th>
            <td>
                <span class="case-title">{{ $t('POLICY.RULE.SIDE_DETAIL.ACTION_DESC')}}<!--조건이 충족하여 규칙이 실패했을 때 다음 작업 실행--></span>
                <button v-if="parentsType === 'cmpl'" type="button" class="buttons-icon btn-toggle-condition" data-type="line" data-size="s"
                        data-icon="expand"
                        :data-expand="hideSatisfaction? true : null"
                        :data-collapse="!hideSatisfaction? true : null"
                        v-on:click="toggleSatisfaction()">collapse / expand</button>

                <div class="rule-condition">

                    <template v-for="condition of rule.cndVal">
                        <!-- template 목록에서 -->
                        <template v-for="template of templateList">

                            <!-- ID 맞는 template 찾았으면 -->
                            <template v-if="condition.tmpltId == template.tmpltId">
                                <!-- condition 간 conjuction 표시 -->
                                <p class="condition" v-if="condition.cjt != 'null' && condition.cjt != null">{{ $t('COMMON.CONJUNCTION.' + condition.cjt) }}</p>

                                <p class="rule">

                                    <template v-for="lang of template[$i18n.locale].lang">
                                        <template v-if="lang['key'] === 'text'">
                                            {{ lang["val"] }}
                                        </template>

                                        <template v-if="lang['key'] === 'input-select'">
                                            <em>
                                                {{condition.cnd.prpts[lang['val']].val}}

                                                <template v-for="lst of template.basicFormation.cnd[lang['val']]['unit']">
                                                    <template v-for="selected of condition.cnd.prpts[lang['val']].slt">
                                                        <template v-if="lst['key'] == selected">
                                                            {{ $t(`BASIC_FORMATION_UNIT.${lst['key']}`) }}
                                                        </template>
                                                    </template>
                                                </template>
                                            </em>
                                        </template>

                                        <template v-if="lang['key'] === 'input'">
                                            <em>
                                                {{condition.cnd.prpts[lang['val']].val}}
                                            </em>
                                        </template>

                                        <template v-if="lang['key'] === 'multi-select'">
                                            <em>
                                                <template v-for="lst of template.basicFormation.cnd[lang['val']]['unit']">
                                                    <template v-for="(selected, sltIdx) of condition.cnd.prpts[lang['val']].slt">
                                                        <template v-if="lst['key'] == selected">
                                                            {{ lst['val'] }} <template v-if="sltIdx < condition.cnd.prpts[lang['val']].slt.length-1">,</template>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-if="condition.cnd.prpts[lang['val']].slt.length == 0 || condition.cnd.prpts[lang['val']].slt[0] == ''">
                                                    <!--                                                    {{template.basicFormation.cnd[lang['val']]}}-->
                                                    <span data-text-color="gray-2">
                                                        {{ $t(`POLICY.RULE.DEFAULT_VALUE.${template.basicFormation.cnd[lang['val']].dfltVal}`) }}
                                                    </span>
                                                </template>
                                            </em>
                                        </template>

                                        <template v-if="lang['key'] === 'select' && (lang['val'] !== 'rsrc' && lang['val'] !== 'peri')">
                                            <em>
                                                <!--                                                {{condition.cnd.prpts[lang['val']].slt[0]}}{{condition.cnd}}.{{lang['val']}}-->
                                                <template v-if="condition.cnd.prpts[lang['val']].slt[0] !== '' && condition.cnd.prpts[lang['val']].slt.length > 0"
                                                          v-for="lst of template.basicFormation.cnd[lang['val']]['unit']">
                                                    <template v-for="selected of condition.cnd.prpts[lang['val']].slt">
                                                        <template v-if="lst['key'] == selected">
                                                            {{ lst['val'] }}
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-if="condition.cnd.prpts[lang['val']].slt.length == 0 || condition.cnd.prpts[lang['val']].slt[0] == ''">
<!--                                                    {{template.basicFormation.cnd[lang['val']]}}-->
                                                    <span data-text-color="gray-2">
                                                        {{ $t(`POLICY.RULE.DEFAULT_VALUE.${template.basicFormation.cnd[lang['val']].dfltVal}`) }}
                                                    </span>
                                                </template>
                                                <!--                                                <template v-if="condition.cnd.prpts[lang['val']].slt[0] == ''">-->
                                                <!--                                                    {{'DD'}}-->
                                                <!--                                                    {{condition.cnd.prpts[lang['val']].dfltVal}}-->
                                                <!--                                                </template>-->
                                            </em>
                                        </template>
                                        <template v-if="lang['key'] === 'select' && lang['val'] === 'rsrc'">
                                            <em>
                                                <template v-if="condition.cnd.prpts[lang['val']].slt[0] !== '' && condition.cnd.prpts[lang['val']].slt.length > 0">
                                                            {{ $t(`PRODUCT.${condition.cnd.prpts[lang['val']].slt[0]}`) }}
                                                </template>
                                                <template v-if="condition.cnd.prpts[lang['val']].slt.length == 0 || condition.cnd.prpts[lang['val']].slt[0] == ''">
                                                    <!--                                                    {{template.basicFormation.cnd[lang['val']]}}-->
                                                    <span data-text-color="gray-2">
                                                        {{ $t(`POLICY.RULE.DEFAULT_VALUE.${template.basicFormation.cnd[lang['val']].dfltVal}`) }}
                                                    </span>
                                                </template>
                                            </em>
                                        </template>
                                        <template v-if="lang['key'] === 'select' && lang['val'] === 'peri'">
                                            <em>
                                                <template v-for="lst of template.basicFormation.cnd[lang['val']]['unit']">
                                                    <template v-for="selected of condition.cnd.prpts[lang['val']].slt">
                                                        <template v-if="lst['key'] == selected">
                                                            {{ $t(`BASIC_FORMATION_UNIT.${lst['key']}`) }}
                                                        </template>
                                                    </template>
                                                </template>
                                            </em>
                                        </template>
                                    </template>
                                </p>

                            </template>
                        </template>
                    </template>

                </div>
            </td>
        </tr>

        <tr>
            <td>
                <!--                <span class="case-title">{{$t('POLICY.RULE.SIDE_DETAIL.ACTION_DESC')}}&lt;!&ndash;조건이 충족하여 규칙이 실패했을 때 다음 작업 실행&ndash;&gt;</span>-->
                <dl v-for="(actn, index) of actnVals" :key="index"
                    v-bind:class="actn.actnId == 'actn_email' ? 'receive-email' : 'general-action'"
                    v-if="checkAccount(actn.actnId)">
                    <template v-for="actnTmplt of actionTemplateList" v-if="actnTmplt.actnId == actn.actnId">
                        <dt>{{actnTmplt.titl}}</dt>
                        <dd class="actn-email" v-if="actnTmplt.actnId == 'actn_email'">
                            <span v-for="user of userList" v-if="checkIncludes(actn.trgt, user.userId)" class="chip selected">
                                {{user.userNm}}({{user.userEmail}})
                            </span>
                        </dd>
                        <dd v-if="actnTmplt.actnId == 'actn_alertnow'">
                            <div v-if="isLoading" class="-wrapper alert-account">
                                <p class="ci ci-loading"></p>
                                <p class="-ml-2 -color-gray-1">{{$t('LABEL.LOADING')}}</p>
                            </div>
                            <div class="alert-account" v-else>
                                <span v-for="(option, idx) of alertOptions" :key="idx" v-if="option.unqKey == actn.trgt" class="chip selected">
                                    {{option.dispNm}}
                                </span>
                            </div>
                        </dd>
                        
                    </template>
                </dl>

                <dl v-if="getActionNullFlag" class="receive-email" disabled>
                    <dt>{{ $t('POLICY.RULE.POPUP.SELECT_NONE')}}</dt>
                    <dd></dd>
                </dl>

                <p v-if="actnVals.length > 0">
                    <input type="checkbox" id="action01" name="action" class="checkbox"
                           :checked="rule.actnExeYn == null || rule.actnExeYn === constants.PARAM.SELECT.Y ? true : null">
                    <label for="action01">{{$t('POLICY.RULE.ACTION_EXECUTION')}}</label>
                </p>
            </td>
        </tr>

        <tr>
            <th scope="row">
                {{ $t('POLICY.LABEL.REMEDIATION')}}<!--개선방법-->
                <button type="button" class="buttons-icon" data-type="ghost" data-size="xs" data-icon="info" data-trigger="tooltip-gnb"
                        :title="$t('POLICY.RULE.SIDE_DETAIL.REMEDIATION_DESC')">info</button>
            </th>
            <td v-html="getRemd">
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>

    import _ from "lodash";
    import {mapGetters} from "vuex";
    export default {
        name: 'SideRuleDetailInfo',
        props: {
            rule: Object,               // Detail 정보에서 열려있는 Rule 정보
            parentsType: String,        // parentsType : {plcy : Policy, cmpl: Compliance}
            actionTemplateList: Array,  // action 정보 리스트
            userList: Array,            // 회사에 가입되어있는 사용자 리스트 정보(Email 수신자 추가시 필요)
            id: {
                type: String,
                default: "rule-detail-info"
            },
            roleCode: {
                type: String,
                default: ""
            }
        },
        data: function () {
            return {
                hideSatisfaction: true,     // 상세조건 Show/Hide flag,
                actionList: [],              // Action List
                actnVals: [],
                isAccuntOpen: false,
                isAccountView: false,
                remainerCnt: 0,
                alertOptions: [],
                isLoading: true,
            }
        },
        created: function () {
            this.initViewGnb()
        },
        mounted(){
            this.renderShowMoreAccountBtn();
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId',
                loginUser: 'user/loginUser'
            }),
            getProducts: function() {
                let self = this;
                let products = [];
                _.forEach(this.rule.cndVal, function(rule) {
                    const ruleProd = _.find(self.templateList, {'tmpltId' : rule.tmpltId});
                    if (ruleProd) {
                        ruleProd.vendor = self.Common.getVendorByKey(ruleProd.vendor);
                        products.push(ruleProd);
                    }
                })
                this.getActnVals();
                return _.unionBy(products, "prod");
            },
            templateList: function() {
                return this.$store.state.templateList;
            },
            getActionNullFlag: function() {
                let isNull = true

                _.forEach(this.rule.actnVal, function(actn) {
                    if (actn.actnId !== null) {
                        isNull = false
                        return false
                    }
                })

                return isNull;
            },
            getRemd: function(){
                let remd = this.rule.siteCd == this.constants.POLICY_TYPE.BEST_PRACTICE
                    ? this.rule[this.$i18n.locale+'RuleRemd']
                    : this.rule.ruleTitl && this.rule.userDefiYn == this.constants.PARAM.SELECT.N
                        ? this.rule[this.$i18n.locale+'RuleRemd']
                        : this.rule.remd;

                // 캐리지리턴 br 태그 치환
                remd = remd ? remd.replace(/(\n|\r\n)/g, '<br>') : remd;
                return remd;
            },
            getShowAlertNow : function() {
                const {ADMIN, SERVICE_MANAGER} = this.constants.ROLE_CODE;
                if (this.roleCode !== ADMIN &&  this.roleCode !== SERVICE_MANAGER) {
                    return false;   
                }
                return true;
            }
        },
        methods: {
            // remove none or null values out of list
            getActnVals() {
                this.actnVals = _.filter(this.rule.actnVal, (actn) => {
                    return (actn.actnId !== null && actn.actnId !== "none");
                });
                const alertActions = this.actnVals.find((actn) => { return actn.actnId == "actn_alertnow" });
                if (alertActions && this.getShowAlertNow) {
                    this.getAlertAction();
                }                
            },
            // TODO : 한개의 Failed Rule의 Action 실행
            execAction(cmplId, ruleId) {

            },
            toggleSatisfaction(){
                this.hideSatisfaction = !this.hideSatisfaction;
            },
            initViewGnb(){
                setTimeout(function(){
                    let target = $('[data-trigger="tooltip-gnb"]');
                    target.tooltipster({
                        delay: 300,
                        // trigger: 'click',
                        animation: 'fade',
                        updateAnimation: 'fade',
                        side: 'bottom',
                        theme : 'tooltip-gnb', // Z-index 올려주는 class 추가
                        arrow: true,
                        contentAsHTML: true,
                        interactive: true,
                    });
                },1000)

            },
            getDefaultValByTemplate(){

            },
            checkAccountRelateRule(vendor) {
              return  _.includes(_.map(this.getProducts, 'vendor'), vendor);
            },
            openAccountSection(){
                this.isAccuntOpen = !this.isAccuntOpen
            },
            renderShowMoreAccountBtn() {
                let acntList = $(`#${this.id} span[data-type=account]`);
                let topPosition;
                this.remainerCnt = 0;
                let self = this;
                $(`#${this.id} span[data-type=account]`).each(function(idx, item) {
                    let currentPosition = item.getBoundingClientRect().top;
                    if (topPosition && topPosition != currentPosition) {
                        self.remainerCnt = acntList.length - idx;
                        self.isAccountView = true;
                        return false;
                    }
                    topPosition = currentPosition;
                });
            },
            getAlertAction() {
                this.isLoading = true;
                const url = `/api/external/${this.curCmpnId}/${this.loginUser.userId}`;
                this.http.get(url).then(response => {
                    const options = _.get(response, "data.data");
                        if (options) {
                        options.forEach(opt => {
                            opt.key = opt.unqKey,
                            opt.value = opt.dispNm
                        })
                    }            
                    this.alertOptions = this.alertOptions.concat(options);
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                });
            },
            checkIncludes(array, item) {
                return _.includes(array, item);
            },
            checkAccount(actnId) {
                if (actnId == 'actn_alertnow') {
                    return this.getShowAlertNow;
                }
                return actnId != null;
            }
        }
    }
</script>

<style>
body[data-wing-expand] .layout-wing-view {
    box-shadow: -5px 16px 8px #888888;
}
.wing-contents .tbl-basic-info>tbody>tr td {
    word-break: break-word;
}
.rule span {
    vertical-align: baseline;
}
.rule em {
    vertical-align: baseline;
}
</style>
<style scoped>
.toggle-accounts .accounts[data-expand] {
    max-height: fit-content;
}
.receive-email dt {
    width: 125px;
}
.alert-account {
    margin-left: 10px;
}
.chip.selected {
    margin-right: 5px;
}
.actn-email {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/rule/SideRuleDetailInfo.vue